import { Link } from "react-router-dom";
export default function Chooseus() {
    return (
        <>
            <section className="why-chooseus-2-section">
                <div className="auto-container">
                    <div className="why-chooseus-2-wrap" style={{marginTop : 0}}>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="section_heading mb_20">
                                    <span className="section_heading_title_small">Why Choose Us</span>
                                    <h2 className="section_heading_title_big">Why People Choose <br /> Newran</h2>
                                </div>
                                <p className="mb_30">It is never an easy task to pick out a good or suitable disability support provider. We at Newran Support Services know how significance a choice that is and we are here to give you a break from the trouble. This is why participants and families go for Newran Support Services: </p>
                                <div className="row">
                                    <div className="col-md-6">
                                        <ul className="service-details-lsit mb_30">
                                            <li>We have a plan, and it is all about you</li>
                                            <li>Our care responds to culture </li>
                                            <li>Our team is compassionate. We care</li>
                                            <li>Our 8+ experience in NDIS industry, supporting participants to live independently and with confidence </li>
                                            <li>Person centred care that tailored to individuals' goals, choices and their lifestyles </li>
                                            <li>Genuine humanly approach, We take time to listen, understand and build trust</li>
                                        </ul>
                                    </div>
                                    <div className="col-md-6">
                                        <ul className="service-details-lsit mb_30">
                                            <li>We adore your opinions; we are eager to respond</li>
                                            <li>From beginning to end, our services run with quality</li>
                                            <li>Flexible supports designed around individuals' goals, No fixed schedules. </li>
                                            <li>24/7 availability for peace of mind when you need support most.</li>
                                            <li>Committed, Compassionate support workers who got to the extra mile to enrich lives. </li>
                                            <li>Wide range of NDIS in-home and in-community supports, including Daily Living assistance, Personal Care, Medication supports, Transport and Community Access.</li>                
                                        </ul>
                                    </div>
                                </div>                        
                            </div>
                            <div className="col-lg-6">
                                <div className="why-chooseus-2-image"><img src="assets/images/resource/NDISService.jpg" alt="" style={{marginTop : 20,borderRadius : 15}}/></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
